import { Button, Divider, Input, InputNumber, Modal } from "antd";
import { useState } from "react";
import { toastError, toastSuccess } from "../../utils/toast";
import { apiUpdateStatusIgnoreWriteAuditLog } from "../../api";
import { useLoading } from "../../context/LoadingContext";

export default function ModalAuditLog({ isOpen, setIsOpen, data, fetchData }: any) {
    const [otpConfirm, setOtpConfirm] = useState('')

    const { setIsLoading } = useLoading()

    const handleUpdate = async () => {
        if (!otpConfirm) {
            toastError('Vui lòng nhập mã OTP xác nhận!')
            return
        }

        try {
            setIsLoading(true)
            const resp = await apiUpdateStatusIgnoreWriteAuditLog({
                value: data.value === 'true' ? 'false' : 'true',
                otpConfirm: otpConfirm,
            })
            if (resp.status === 200) {
                fetchData()
                setIsOpen(false)
                toastSuccess('Cập nhật trạng thái thành công')
                setOtpConfirm('')
            }
        } catch (error) {
            toastError('Cập nhật trạng thái thất bại')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            title="Cập nhật trạng thái Audit Log"
            open={isOpen}
            onOk={() => alert()}
            onCancel={() => setIsOpen(false)}
            footer={[
                <Button onClick={handleUpdate} type="primary" danger={data.value !== 'true'}>
                    {data.value === 'true' ? 'Bật' : 'Tắt'}
                </Button>
            ]}>
            <Divider />
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    )
}
